export const contractorFormLastNameField = "customerAddress.lastName";
export const contractorFormFirstNameField = "customerAddress.firstName";
export const contractorFormPhoneNumberField = "customerAddress.phoneNumber";
export const contractorFormZipCodeField = "customerAddress.postalCode";
export const contractorFormPrefectureField = "customerAddress.prefectureCode";
export const contractorFormCityField = "customerAddress.address1";
export const contractorFormAddressField = "customerAddress.address2";
export const contractorFormBuildingNameAndRoomNumberField = "customerAddress.buildingName";
export const contractorFormMailField = "customerAddress.mail";

export const contractorFormTestId = "components/fragments/argyle/contractor-form/form";
export const contractorFormTitleTestId = "components/fragments/argyle/contractor-form/title";
export const contractorFormDescriptionTestId = "components/fragments/argyle/contractor-form/description";
